import { EntityKeys, QueryType } from 'utils/reactQuery'

import { RoleMimetype } from 'constants/API'
import { VisualPurchaseSessionListResponse } from 'models/visuals'
import { useAPI } from 'utils/API'
import { useQuery } from '@tanstack/react-query'

enum Endpoints {
  LIST_VISUALS = '/order/{sessionId}/visual/all',
}

export function useListPurchaseSessionVisuals(sessionId: string, enabled = true) {
  const api = useAPI<Endpoints>()

  return useQuery({
    queryKey: [EntityKeys.PURCHASE_SESSION_VISUAL, QueryType.LIST, { sessionId }],
    queryFn: () => api.get<VisualPurchaseSessionListResponse>(
      Endpoints.LIST_VISUALS,
      { sessionId },
      false,
      { headers: { Accept: RoleMimetype.CLIENT } }
    ),
    enabled: !!sessionId && enabled,
  })
}
